import OkTableConfigType from '@/@bya3/components/tables/ok-table/OkTableConfigType'
import { API_URL } from '@/constants/config'
import store from '@/store'

const InvoicesTableConfig: OkTableConfigType = {
  mode: 'remote',
  url: `${API_URL}/admin/invoices`,
  rowsPath: 'invoices',
  rowClickable: true,
  attachPageId: false,
  actionFirst: true,
  actions: [
    {
      label: 'forms.edit',
      eventName: 'edit',
      icon: 'EditIcon',
    },
    {
      label: 'forms.delete',
      eventName: 'delete',
      icon: 'Trash2Icon',
    },
    {
      label: 'invoice.change-status',
      eventName: 'status',
      icon: 'MinusSquareIcon',
    },
  ],
  columns: [
    {
      label: 'page.name',
      field: 'page',
    },
    {
      label: 'general.media-type',
      field: 'media_type',
    },
    {
      label: 'invoice.paid',
      field: 'paid',
    },
    {
      label: 'invoice.bya3com',
      field: 'bya3com',
    },
    {
      label: 'invoice.commission',
      field: 'commission',
    },
    {
      label: 'invoice.subscribed-at',
      field: 'subscribed_at',
    },
    {
      label: 'invoice.expires-at',
      field: 'expires_at',
    },
    {
      label: 'page.package-price',
      field: 'package-price',
    },
    {
      label: 'invoice.discount',
      field: 'discount',
    },
    {
      label: 'invoice.period',
      field: 'period',
    },
  ],
  paginationOptions: {
    enabled: true,
  },
  sortOptions: {
    enabled: false,
  },

  filters: [
    {
      label: 'page.name',
      query: 'page_id',
      colLength: 3,
      type: 'autocomplete',
      multiple: false,
    },
    {
      label: 'invoice.paid',
      query: 'paid',
      colLength: 3,
      type: 'select',
      multiple: false,
      options: [{ text: 'general.yes', value: 1 }, { text: 'general.no', value: 0 }],
      optionsLabel: { keyLabel: 'text', valueLabel: 'value', translate: true },
    },
    {
      label: 'page.package',
      query: 'package',
      colLength: 3,
      type: 'select',
      multiple: false,
      options: () => store.getters['subscription/packages'],
      optionsLabel: { keyLabel: 'name', valueLabel: 'id', translate: false },
    },
    {
      label: 'page.referral',
      query: 'referral',
      colLength: 3,
      type: 'select',
      multiple: false,
      options: () => store.getters['auth/referrals'],
      optionsLabel: { keyLabel: 'name', valueLabel: 'id', translate: false },
    },
    {
      label: 'creator',
      query: 'creator',
      colLength: 3,
      type: 'select',
      multiple: false,
      options: () => store.getters['auth/referrals'],
      optionsLabel: { keyLabel: 'name', valueLabel: 'id', translate: false },
    },
    {
      label: 'page.expire-date',
      query: 'expires',
      colLength: 3,
      type: 'range',
      range_type: 'date',
    },
    {
      label: 'general.media-type',
      query: 'media_type',
      colLength: 3,
      type: 'select',
      multiple: false,
      options: [{ text: 'general.feature', value: 'feature' }, { text: 'general.fb', value: 'fb' }, { text: 'general.ig', value: 'ig' }],
      optionsLabel: { keyLabel: 'text', valueLabel: 'value', translate: true },
    },
  ],
}

export default InvoicesTableConfig
